// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-product-form {
    max-width: 500px;
    margin: 20px auto;
    padding: 20px;
    color: white;
    border-radius: 8px;
  }
  
  .add-product-form h2 {
    text-align: center;
    color: white;
  }
  
  .form-group {
    margin-bottom: 15px;
    color: white;
  }

  .form-group h4 {
    color: white;
  }
  
  input {
    width: 100%;
    padding: 8px;
    border: 1px solid #ddd;
    border-radius: 4px;
    color: white;
  }

  select {
    width: 100%;
    padding: 8px;
    border: 1px solid #ddd;
    border-radius: 4px;
  }
  
  .checkbox-group {
    display: flex;
    flex-direction: column;
  }
  
  .checkbox-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
  }
  
  .checkbox-row span {
    flex-grow: 1;
  }
  
  .submi-button {
    width: 100%;
    padding: 10px;
    background-color: black;
    color: white;
    border: 1px solid white;
    border-radius: 4px;
    cursor: pointer;
  }

  .status-message {
    margin-top: 20px;
    font-size: 1rem;
    text-align: center;
    color: #d9534f;
  }
  
  .error-message {
    color: red;
    font-size: 0.9rem;
  }
  
  .toggl-button {
    margin-top: 10px;
    background: none;
    border: none;
    color: gray;
    text-decoration: underline;
    cursor: pointer;
  }
  
  .toggl-button:hover {
    color: white;
  }
  `, "",{"version":3,"sources":["webpack://./src/private/Admin/AddProductForm.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,UAAU;IACV,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,0BAA0B;IAC1B,eAAe;EACjB;;EAEA;IACE,YAAY;EACd","sourcesContent":[".add-product-form {\n    max-width: 500px;\n    margin: 20px auto;\n    padding: 20px;\n    color: white;\n    border-radius: 8px;\n  }\n  \n  .add-product-form h2 {\n    text-align: center;\n    color: white;\n  }\n  \n  .form-group {\n    margin-bottom: 15px;\n    color: white;\n  }\n\n  .form-group h4 {\n    color: white;\n  }\n  \n  input {\n    width: 100%;\n    padding: 8px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    color: white;\n  }\n\n  select {\n    width: 100%;\n    padding: 8px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n  }\n  \n  .checkbox-group {\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .checkbox-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 10px;\n  }\n  \n  .checkbox-row span {\n    flex-grow: 1;\n  }\n  \n  .submi-button {\n    width: 100%;\n    padding: 10px;\n    background-color: black;\n    color: white;\n    border: 1px solid white;\n    border-radius: 4px;\n    cursor: pointer;\n  }\n\n  .status-message {\n    margin-top: 20px;\n    font-size: 1rem;\n    text-align: center;\n    color: #d9534f;\n  }\n  \n  .error-message {\n    color: red;\n    font-size: 0.9rem;\n  }\n  \n  .toggl-button {\n    margin-top: 10px;\n    background: none;\n    border: none;\n    color: gray;\n    text-decoration: underline;\n    cursor: pointer;\n  }\n  \n  .toggl-button:hover {\n    color: white;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
